import { memo, type FC } from 'react';

import { dataTableGroup } from '../../constants.ts';
import { useTableContext } from '../../context.tsx';
import { ClickableTitle, GroupHeaderWrapper, GroupWrapper, Title } from './styled.ts';
import type { GroupProps } from './types.ts';

export const Group: FC<GroupProps> = memo(function Group({ children, className, title, titleOnClick, tag, actions }) {
  const { inner } = useTableContext();
  const hasActions = Boolean(actions) || Boolean(tag);

  return (
    <GroupWrapper className={className} $inner={inner} {...dataTableGroup}>
      <GroupHeaderWrapper $inner={inner} $hasActions={hasActions}>
        {titleOnClick ? <ClickableTitle onClick={titleOnClick}>{title}</ClickableTitle> : <Title>{title}</Title>}
        {tag}
        {actions}
      </GroupHeaderWrapper>
      {children}
    </GroupWrapper>
  );
});
